import type { UserLogged } from '../types/Auth'

export function getLocalAccessToken() {
	const userStorage = localStorage.getItem('user')

	if (userStorage) {
		const user: UserLogged = JSON.parse(userStorage)
		return user?.access_token
	}

	return null
}

export function getLocalRefreshToken() {
	const userStorage = localStorage.getItem('user')

	if (userStorage) {
		const user: UserLogged = JSON.parse(userStorage)
		return user?.refresh_token.id
	}

	return null
}

export function updateLocalUser(user: UserLogged) {
	localStorage.setItem('user', JSON.stringify(user))
}
